// TrendingSwiper.js
import React from "react";
import { Container, Typography, Box, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/swiper.min.css";
// import "swiper/modules/navigation/navigation.min.css";
// import "swiper/modules/pagination/pagination.min.css";
import { Pagination, Navigation } from "swiper/modules";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import StarIcon from "@mui/icons-material/Star";
import Image1 from "../../assets/images/AboutCompanyImage.png";
import '../../assets/css/swiper.css'
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import PadamParekh from '../../assets/images/Padam Parekh.png'
import Vinaykumar from '../../assets/images/Vinay Kumar.png'
import Prabhu from '../../assets/images/prabhu.jpg'
import Shivkumar from '../../assets/images/Shiv Kumar.png'
import Shubhamkothari from '../../assets/images/Shubham Kothari.png'
import Abhinandan from '../../assets/images/Abhinandan Jain.png'
import Vinodbasari from '../../assets/images/Vinod Basari.png'
import Rahulmasal from '../../assets/images/Rahul Masal.png'
import AkshataA from '../../assets/images/Akshata Arakerimath.png'
import Priyadarshini from '../../assets/images/Priyadarshini Biradar.png'
import Ravioursang from '../../assets/images/Ravi Oursang.png'
import Rohanpolley from '../../assets/images/Rohan Polley.png'
import Yashkawdiya from '../../assets/images/Yash Kawdiya.png'
import SachinHosamani from '../../assets/images/Sachin Hosamani.png'
import LakhannaA from '../../assets/images/Lakhanna Awaji.png'





const SlideImage = styled("img")({
  width: "80%",
  borderRadius: "10px",
});

const PersonName = styled(Typography)({
  // fontSize: "1.5em",
  color: "#1E53E8;",
  fontFamily: "Roboto Flex",
      textAlign: "center",
      fontWeight: 700,
      fontSize: "28px",
      lineHeight: "140%",
      fontStyle:"italic",
      "@media (max-width: 600px)": {
        fontSize: "32px", // Adjust the font size for smaller screens
        // textAlign: "center",
        // lineHeight: "60px",
      },
      "@media (max-width: 1024px)": {

            fontFamily: "Sofia Sans Extra Condensed",
            fontSize: "38px",
            // fontStyle: normal;
            fontWeight: 700,
            lineHeight: "100%", /* 38px */
            // font-variant: all-small-caps;
      },
});

const PersonRole = styled(Typography)({
  // fontSize: "1.2em",

  lineHeight: "33.6px",
  color: "#000000",
  fontFamily: "Roboto Flex",
  fontSize: "22px",
  fontStyle:"normal",
  textAlign: "center",
  "@media (max-width: 600px)": {
    fontSize: "12px",
    textAlign: "center",
  },

});


const IconContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: "10px",
  marginTop: "10px",
  "& .MuiSvgIcon-root": {
    cursor: "pointer",
  },
});

const LinkedInIconStyled = styled(LinkedInIcon)({
  color: "#0077b5",
});

const EmailIconStyled = styled(MailOutlinedIcon)({
  color: "#000000",
  // border: "1px solid #000",
  // borderRadius: "50%",
});

const SliderArrow = styled(IconButton)({
  backgroundColor: "#fff",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
});

const TrendingSwiper = () => {
  const slides = [
    { img: PadamParekh, name: "Mr. Padam Parekh",linkedIn: "https://www.linkedin.com/in/padam-parekh-8a9490109", email: "padam@megaconnect.cloud"},
    { img: Vinaykumar, name: "Mr. Vinay Kumar",linkedIn: "https://www.linkedin.com/in/vinay-kumar-95b276187?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app", email: "vinaykumar01@techmega.cloud"},
    { img: Prabhu, name: "Mr. Prabhu C",linkedIn: "https://www.linkedin.com/", email: "padam.parekh@example.com"},
    { img: Shivkumar, name: "Mr. Shiv Kumar", linkedIn: "https://www.linkedin.com", email: "padam.parekh@example.com"},
    { img: Shubhamkothari, name: "Mr. Shubham Kothari", linkedIn: "https://www.linkedin.com/in/kotharishubham/", email: "shubhamkothari05@megaconnect.cloud"},
    { img: Abhinandan, name: "Mr. Abhinandan Jain", linkedIn: "https://www.linkedin.com/in/abhi1005/", email: "abhinandan@megaconnect.cloud"},
    { img: Vinodbasari, name: "Mr. Vinod Basari", linkedIn: "https://www.linkedin.com/in/vinod-basari-50357a220/?original_referer=https%3A%2F%2Fwww%2Elinkedin%2Ecom%2F&originalSubdomain=in", email: "vinodbasari@megaconnect.cloud"},
    { img: Rahulmasal, name: "Mr. Rahul Masal", linkedIn: "https://www.linkedin.com/in/rahul-masal-100009196/", email: "rahulmasal006@megaconnect.cloud"},
    { img: AkshataA, name: "Ms. Akshata Arakerimath", linkedIn: "https://www.linkedin.com/in/akshata-arakerimath-4566701b5?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", email: "akshataarakerimath06@megaconnect.cloud"},
    { img: Priyadarshini, name: "Ms. Priyadarshini Biradar", linkedIn: "https://in.linkedin.com/in/priyadarshini-biradar-26927b202", email: "priyadarshini003@megaconnect.cloud"},
    { img: Ravioursang, name: "Mr. Ravi Oursang", linkedIn: "https://www.linkedin.com/in/ravi-oursang-53156413b/", email: "ravioursang005@megaconnect.cloud"},
    { img: Rohanpolley, name: "Mr. Rohan Polley", linkedIn: "https://www.linkedin.com/in/rohan-polley-5823b6201/", email: "rohanp@megaconnect.cloud"},
    { img: Yashkawdiya, name: "Mr. Yash Kawdiya", linkedIn: "https://www.linkedin.com/in/yash-kawdiya-2808a5264/", email: "yashkawdiya@megaconnect.cloud"},
    { img: SachinHosamani, name: "Mr. Sachin Hosamani", linkedIn: "https://www.linkedin.com/in/sachin-hosamani-0413b4182?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", email: "sachin@megaconnect.cloud"},
    { img: LakhannaA, name: "Mr. Lakkanna Awaji", linkedIn: "https://www.linkedin.com/in/lakkappa-awaji-970999251?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", email: "lakkanna@megaconnect.cloud"},
  ];

  return (
    <section id="trending">
      <Container>
        <Typography
          variant="subtitle1"
          align="center"
          color="textSecondary"
          className="textCenter"
        >
          {/* - popular Delivery - */}
        </Typography>
        <Typography variant="h4" align="center" className="sectionHeading">
          {/* Trending food */}
        </Typography>
      </Container>
      <Container>
        <Swiper
          className="trendingSlider"
          modules={[Navigation]}
         
          slidesPerView={3}
          breakpoints={{
            320:{
              slidesPerView: 2,
            },
            640: {
              slidesPerView: 3,
             
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 3,
             
            },
            // when window width is >= 1024px
            1024: {
              slidesPerView: 3,
            
            },
           
          }}
          centeredSlides={true}
          loop={true}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          pagination={{ clickable: true }}
          onSlideChange={(swiper) => {
            const slides = swiper.slides;
            slides.forEach((slide, index) => {
              slide.style.transition = "transform 0.3s, filter 0.3s";
              if (index === swiper.activeIndex) {
                slide.style.transform = "scale(1.2)";
                slide.style.filter = "grayscale(0)";
              } else {
                slide.style.transform = "scale(1)";
                slide.style.filter = "grayscale(100%)";
              }
            });
          }}
          onInit={(swiper) => {
            const slides = swiper.slides;
            slides.forEach((slide, index) => {
              slide.style.transition = "transform 0.3s, filter 0.3s";
            
              if (index === swiper.activeIndex) {
                slide.style.transform = "scale(1.2)";
                slide.style.filter = "grayscale(0)";
              } else {
                slide.style.transform = "scale(1)";
                slide.style.filter = "grayscale(100%)";
              }
            });
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index} className="trendingSlide" >
              <Box display="flex" flexDirection="column" alignItems="center" mt={5.2}>
                <SlideImage
                  src={slide.img}
                  alt="Trending"
                  className="trendingSlideImg"
                />
                <Box textAlign="center" className="trendingSlideContent">
                  <PersonName sx={{marginTop:"30px",fontSize:"1.5rem"}} className="foodPrice">{slide.name}</PersonName>
                  <Box mt={1} className="trendingSlideContentBottom">
                    <PersonRole className="foodName">{slide.Role}</PersonRole>
                    <IconContainer sx={{marginTop:"12px"}} className="iconContainer">
                    <a href={slide.linkedIn} target="_blank" rel="noopener noreferrer">
                      <LinkedInIconStyled />
                    </a>
                    <a href={`mailto:${slide.email}`} target="_blank" rel="noopener noreferrer">
                      <EmailIconStyled />
                    </a>
                  </IconContainer>
                  </Box>
                </Box>
              </Box>
            </SwiperSlide>
          ))}
          <Box
            display="flex"
            justifyContent="space-between"
            mt={2}
            className="trendingSliderControl"
          >
            <SliderArrow className="swiper-button-prev sliderArrow">
              <ArrowBackIosIcon />
            </SliderArrow>
            <SliderArrow className="swiper-button-next sliderArrow">
              <ArrowForwardIosIcon />
            </SliderArrow>
          </Box>
        </Swiper>
      </Container>
    </section>
  );
};

export default TrendingSwiper;
